import React from 'react';
import { InteractiveQuiz } from '../components/InteractiveQuiz';
import { Lightbulb } from 'lucide-react';
export const ShiShen: React.FC = () => {
  const quizQuestions = [{
    question: "日主为'甲'木，遇到'戊'土，'戊'土是日主的什么十神？",
    options: ['正财', '偏财', '正官', '七杀'],
    correctAnswer: 1,
    explanation: '甲木克戊土（我克者为财），甲为阳木，戊为阳土，同性相克为偏财。'
  }, {
    question: '代表母亲、学业、包容的十神是？',
    options: ['食神', '伤官', '正印', '偏财'],
    correctAnswer: 2,
    explanation: '正印代表生我者（异性），主母亲、学业、名誉、包容心。'
  }];
  const shiShenData = [{
    name: '比肩',
    type: '同我',
    yinYang: '同性',
    keywords: '朋友、兄弟、竞争、自我',
    desc: '与日主五行相同且阴阳相同。代表自我意识强，独立，朋友多，但也容易有竞争。'
  }, {
    name: '劫财',
    type: '同我',
    yinYang: '异性',
    keywords: '姐妹、合作、破财、冲动',
    desc: '与日主五行相同但阴阳不同。代表行动力强，善于交际，但也容易冲动消费或破财。'
  }, {
    name: '食神',
    type: '我生',
    yinYang: '同性',
    keywords: '才华、享受、温和、晚辈',
    desc: '日主所生且阴阳相同。代表温和的表达，艺术才华，口福，懂得享受生活。'
  }, {
    name: '伤官',
    type: '我生',
    yinYang: '异性',
    keywords: '创新、叛逆、傲气、表达',
    desc: '日主所生且阴阳不同。代表激烈的表达，创新能力强，不服管教，才华横溢。'
  }, {
    name: '偏财',
    type: '我克',
    yinYang: '同性',
    keywords: '大财、父亲、慷慨、投机',
    desc: '日主所克且阴阳相同。代表意外之财，投资，父亲，为人慷慨大方。'
  }, {
    name: '正财',
    type: '我克',
    yinYang: '异性',
    keywords: '工资、妻子、节俭、踏实',
    desc: '日主所克且阴阳不同。代表稳定的收入（如工资），男命的妻子，做事踏实保守。'
  }, {
    name: '七杀',
    type: '克我',
    yinYang: '同性',
    keywords: '压力、权力、果断、小人',
    desc: '克日主且阴阳相同。代表巨大的压力，但也代表魄力、执行力和武职权力。'
  }, {
    name: '正官',
    type: '克我',
    yinYang: '异性',
    keywords: '地位、丈夫、守法、约束',
    desc: '克日主且阴阳不同。代表合理的约束，地位，名誉，女命的丈夫，遵纪守法。'
  }, {
    name: '偏印',
    type: '生我',
    yinYang: '同性',
    keywords: '偏门、孤僻、直觉、继母',
    desc: '生日主且阴阳相同。代表非传统的学问（如玄学），直觉力强，性格可能偏孤僻。'
  }, {
    name: '正印',
    type: '生我',
    yinYang: '异性',
    keywords: '母亲、学业、名誉、善良',
    desc: '生日主且阴阳不同。代表母亲，正统学历，贵人相助，心地善良包容。'
  }];
  return <div className="space-y-12" data-id="element-338">
      <div className="text-center mb-10" data-id="element-339">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-340">
          十神解析
        </h1>
        <p className="text-ink-light" data-id="element-341">
          八字中的社会关系与心理投射，断事的核心依据。
        </p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-342">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-343">
          <Lightbulb size={24} data-id="element-344" />
        </div>
        <div data-id="element-345">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-346">
            小白记忆法：社会角色代入
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-347">
            把日主当成你自己：
            <br data-id="element-348" />
            <strong data-id="element-349">生我者（印星）：</strong>{' '}
            像母亲一样保护我、生养我。正印是亲妈（温柔），偏印是后妈（严厉）。
            <br data-id="element-350" />
            <strong data-id="element-351">我生者（食伤）：</strong>{' '}
            我生出来的孩子、我的才华。食神是乖孩子（温和），伤官是熊孩子（叛逆）。
            <br data-id="element-352" />
            <strong data-id="element-353">克我者（官杀）：</strong>{' '}
            管我的领导、法律。正官是好领导（合理约束），七杀是严苛的老板（压力）。
            <br data-id="element-354" />
            <strong data-id="element-355">我克者（财星）：</strong>{' '}
            我能掌控的钱财、物品。正财是死工资（稳定），偏财是股票彩票（投机）。
            <br data-id="element-356" />
            <strong data-id="element-357">同我者（比劫）：</strong>{' '}
            我的兄弟姐妹、同事。比肩是好哥们（平等），劫财是竞争对手（抢钱）。
          </p>
        </div>
      </div>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-358">
        {shiShenData.map((ss, idx) => <div key={idx} className="bg-white ink-border p-6 rounded-lg card-hover shadow-sm" data-id="element-359">
            <div className="flex justify-between items-center mb-4 border-b border-paper-dark pb-3" data-id="element-360">
              <h3 className="text-xl font-serif font-bold text-gold-dark" data-id="element-361">
                {ss.name}
              </h3>
              <span className="text-xs bg-paper px-2 py-1 rounded text-ink-light border border-paper-dark font-medium" data-id="element-362">
                {ss.type} · {ss.yinYang}
              </span>
            </div>
            <div className="text-sm text-cinnabar mb-3 font-bold bg-cinnabar/5 inline-block px-2 py-1 rounded" data-id="element-363">
              {ss.keywords}
            </div>
            <p className="text-ink-light text-sm leading-relaxed" data-id="element-364">{ss.desc}</p>
          </div>)}
      </section>

      <section className="mt-16" data-id="element-365">
        <InteractiveQuiz questions={quizQuestions} data-id="element-366" />
      </section>
    </div>;
};